let angularLoaded = false;
// let lastBuild = "";

export async function loadAngularWC() {
  if (angularLoaded) return;
  angularLoaded = true;

  const res = await fetch("/angular/index.html", { cache: "no-cache" });
  if (!res.ok) {
    console.error("Angular bundle not found. Run Angular build.");
    return;
  }

  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, "text/html");

  /************************************
   * LOAD CSS
   ************************************/
  const cssLinks = Array.from(doc.querySelectorAll("link[rel='stylesheet']"));

  for (const link of cssLinks) {
    let href = link.getAttribute("href");
    if (!href) continue;

    if (href.startsWith("/")) href = href.substring(1);
    const finalHref = "/angular/" + href;

    // prevent duplicate load
    if (document.querySelector(`link[href="${finalHref}"]`)) continue;

    const styleEl = document.createElement("link");
    styleEl.rel = "stylesheet";
    styleEl.href = finalHref;
    document.head.appendChild(styleEl);
  }

  /************************************
   * LOAD JS
   ************************************/
  const scripts = Array.from(doc.querySelectorAll("script[src]"));

  for (const script of scripts) {
    let src = script.getAttribute("src");
    if (!src) continue;

    if (src.startsWith("/")) src = src.substring(1);
    const finalSrc = "/angular/" + src;

    if (document.querySelector(`script[src="${finalSrc}"]`)) continue;

    const s = document.createElement("script");
    s.type = "module";
    s.src = finalSrc;
    document.body.appendChild(s);
  }

  /************************************
*   AUTO RELOAD ON ANGULAR REBUILD FOR LOCAL DEV
  ************************************/
  // setInterval(async () => {
  //   try {
  //     const r = await fetch("/angular/build.txt?ts=" + Date.now(), {
  //       cache: "no-store"
  //     });

  //     const text = await r.text();

  //     if (lastBuild && lastBuild !== text) {
  //       console.log("Angular changed → reloading");
  //       window.location.reload();
  //     }

  //     lastBuild = text;
  //   } catch (err) {
  //     console.error("Error checking Angular build:", err);
  //   }
  // }, 2000);
}

